import { IP_COUNTRY_QUERY, USER_COUNTRY_QUERY, USER_UPDATED, USER_QUERY, USER_COUNTRY_UPDATED } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { IP_COUNTRY_COOKIE } from './country.constants.js';

var CountryService = /** @class */ (function () {
    function CountryService(cookie) {
        this.cookie = cookie;
        this.cookieCountry = null;
        this.cookieCountry = this.readCookie();
        this.registerCookieCountryQuery();
        this.registerUserCountryQuery();
        this.subscribeToUserCountryChanges();
    }
    CountryService.prototype.getCookieCountry = function () {
        return this.cookieCountry;
    };
    CountryService.prototype.readCookie = function () {
        var ipCookie = this.cookie.read(IP_COUNTRY_COOKIE);
        if (!ipCookie) {
            return null;
        }
        return ipCookie.toUpperCase();
    };
    CountryService.prototype.registerCookieCountryQuery = function () {
        var _this = this;
        window.queryBus.subscribe(IP_COUNTRY_QUERY, function () {
            return _this.cookieCountry;
        });
    };
    CountryService.prototype.registerUserCountryQuery = function () {
        var _this = this;
        window.queryBus.subscribe(USER_COUNTRY_QUERY, function () { return __awaiter(_this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, this.getUserCountry(user)];
                }
            });
        }); });
    };
    CountryService.prototype.subscribeToUserCountryChanges = function () {
        var _this = this;
        this.getUser().then(function (user) {
            _this.publishUserCountry(user);
            window.eventBus.subscribe(USER_UPDATED, function (event) {
                _this.publishUserCountry(event.payload);
            });
        });
    };
    CountryService.prototype.getUser = function () {
        return window.queryBus.query(USER_QUERY);
    };
    CountryService.prototype.publishUserCountry = function (user) {
        window.eventBus.publish(USER_COUNTRY_UPDATED, this.getUserCountry(user));
    };
    CountryService.prototype.getUserCountry = function (user) {
        var _a;
        return user ? user.country : (_a = this.cookieCountry) !== null && _a !== void 0 ? _a : null;
    };
    return CountryService;
}());

export { CountryService };
